/**
 * @generated SignedSource<<b3061cd7003265d7f754eb699d1d6d0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RecordingMediaType = "AUDIO" | "VIDEO";
import { FragmentRefs } from "relay-runtime";
export type ClipModal_clip$data = {
  readonly baseRecording: {
    readonly id: string;
    readonly meetingCallEnd: string | null;
    readonly meetingCallStart: string;
    readonly note: {
      readonly eventEnd?: string | null;
      readonly eventStart?: string | null;
      readonly id: string;
      readonly url?: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_note">;
    } | null;
    readonly title: string;
  } | null;
  readonly clipEnd: number;
  readonly clipStart: number;
  readonly id: string;
  readonly mediaType: RecordingMediaType;
  readonly ownerAccount: {
    readonly logo: string;
    readonly name: string;
  };
  readonly postedInChannels: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly summary: string | null;
  readonly title: string;
  readonly transcript: any | null;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_RenameClipModal_clip" | "TranscriptPanel_Transcript_meetingRecording" | "TranscriptVideo_meetingRecording" | "utils_useGetURL_recording">;
  readonly " $fragmentType": "ClipModal_clip";
};
export type ClipModal_clip$key = {
  readonly " $data"?: ClipModal_clip$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClipModal_clip">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "public",
    "value": false
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClipModal_clip",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clipEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clipStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcript",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Channel",
      "kind": "LinkedField",
      "name": "postedInChannels",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "baseRecording",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingCallStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingCallEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "note",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "eventStart",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "eventEnd",
                  "storageKey": null
                }
              ],
              "type": "Note",
              "abstractKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TranscriptPanel_note"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "TranscriptVideo_meetingRecording"
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_Transcript_meetingRecording"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useGetURL_recording"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClipsPanel_RenameClipModal_clip"
    }
  ],
  "type": "MeetingRecordingClip",
  "abstractKey": null
};
})();

(node as any).hash = "aff930c8797fc2fc0c5fcf80808418fb";

export default node;
